import React from "react";

import { Router, Switch, Route } from "react-router-dom";

import history from "./History";

/*
|--------------------------------------------------------------------------
| GUARDS
|--------------------------------------------------------------------------
*/

import AuthGuard from "./guards/AuthGuard";

import GuestGuard from "./guards/GuestGuard";

import PlatformAuthGuard from "./guards/PlatformAuthGuard.js";

/*
|--------------------------------------------------------------------------
| TENANT AUTH
|--------------------------------------------------------------------------
*/

import Login from "./components/auth/Login";

import EmployeeOfferPublic from "./components/public/EmployeeOfferPublic";

/*
|--------------------------------------------------------------------------
| PLATFORM AUTH
|--------------------------------------------------------------------------
*/

import PlatformLogin from "./components/platformAuth/PlatformLogin.js";

/*
|--------------------------------------------------------------------------
| PLATFORM
|--------------------------------------------------------------------------
*/

import PlatformDashboard from "./components/dashboard/components/platformComponent/PlatformDashboard.js";

import PlatformBusinessList from "./components/dashboard/components/platformComponent/business/PlatformBusinessList.js";

import PlatformBusinessDetails from "./components/dashboard/components/platformComponent/business/PlatformBusinessDetails.js";

/*
|--------------------------------------------------------------------------
| TENANT PROFILE
|--------------------------------------------------------------------------
|
| Keeping your current actual path.
|--------------------------------------------------------------------------
*/

import TenantProfile from "./components/dashboard/components/platformComponent/business/components/tenantProfile/TenantProfile.js";

/*
|--------------------------------------------------------------------------
| EXISTING ADMIN MODULES
|--------------------------------------------------------------------------
*/

import SupportChat from "./components/dashboard/components/AdminComponent/SupportChat";

import UserManagement from "./components/dashboard/components/platformComponent/UserManagement/index.jsx";

import CustomerService from "./components/dashboard/components/AdminComponent/CustomerService";

import InventoryManagement from "./components/dashboard/components/AdminComponent/InventoryManagement/InventoryManagement";

import OrderManagement from "./components/dashboard/components/AdminComponent/OrderManagement";

// import EmployeeManagement from "./components/dashboard/components/AdminComponent/EmployeeManagement";
// import EmployeeAdvance from "./components/dashboard/components/AdminComponent/EmployeeManagement";
// import EmployeeAttendance from "./components/dashboard/components/AdminComponent/EmployeeManagement";
// import EmployeeLeave from "./components/dashboard/components/AdminComponent/EmployeeManagement";
// import EmployeeSalary from "./components/dashboard/components/AdminComponent/EmployeeManagement";
import {
  EmployeeManagement,
  EmployeeAdvance,
  EmployeeAttendance,
  EmployeeLeave,
  EmployeeSalary,
  EmployeeOfferManagement,
} from "./components/dashboard/components/AdminComponent/EmployeeManagement";

import TaskManagement from "./components/dashboard/components/AdminComponent/TaskManagement";

/*
|--------------------------------------------------------------------------
| QUOTATIONS
|--------------------------------------------------------------------------
*/

import QuotationPage from "./components/dashboard/components/AdminComponent/BillingManagement/Quotations";

import QuotationFormPage from "./components/dashboard/components/AdminComponent/BillingManagement/Quotations/QuotationFormPage";

import QuotationHistoryPage from "./components/dashboard/components/AdminComponent/BillingManagement/Quotations/QuotationHistoryPage";

import QuotationViewPage from "./components/dashboard/components/AdminComponent/BillingManagement/Quotations/QuotationViewPage";

import QuotationPrintPage from "./components/dashboard/components/AdminComponent/BillingManagement/Quotations/QuotationPrintPage";

/*
|--------------------------------------------------------------------------
| SALE INVOICES
|--------------------------------------------------------------------------
*/

import SaleInvoiceManagement from "./components/dashboard/components/AdminComponent/BillingManagement/SaleInvoices";

import SaleInvoicePrintPage from "./components/dashboard/components/AdminComponent/BillingManagement/SaleInvoices/SaleInvoicePrintPage";

import SaleInvoiceFormPage from "./components/dashboard/components/AdminComponent/BillingManagement/SaleInvoices/SaleInvoiceFormPage";

import SaleInvoiceViewPage from "./components/dashboard/components/AdminComponent/BillingManagement/SaleInvoices/SaleInvoiceViewPage";

/*
|--------------------------------------------------------------------------
| PAYMENTS
|--------------------------------------------------------------------------
*/

import PaymentListPage from "./components/dashboard/components/AdminComponent/BillingManagement/Payments/PaymentListPage";

/*
|--------------------------------------------------------------------------
| CREDIT NOTES
|--------------------------------------------------------------------------
*/

import CreditNoteListPage from "./components/dashboard/components/AdminComponent/BillingManagement/CreditNotes/CreditNoteListPage";

import CreditNoteViewPage from "./components/dashboard/components/AdminComponent/BillingManagement/CreditNotes/CreditNoteViewPage";

/*
|--------------------------------------------------------------------------
| CUSTOMER LEDGER
|--------------------------------------------------------------------------
*/

import CustomerLedgerPage from "./components/dashboard/components/AdminComponent/BillingManagement/CustomerLedger/CustomerLedgerPage";

/*
|--------------------------------------------------------------------------
| DEBIT NOTES
|--------------------------------------------------------------------------
*/

import DebitNoteListPage from "./components/dashboard/components/AdminComponent/BillingManagement/DebitNotes/DebitNoteListPage";

import DebitNoteViewPage from "./components/dashboard/components/AdminComponent/BillingManagement/DebitNotes/DebitNoteViewPage";

/*
|--------------------------------------------------------------------------
| SUPPLIER LEDGER
|--------------------------------------------------------------------------
*/

import SupplierLedgerDetailsPage from "./components/dashboard/components/AdminComponent/BillingManagement/SupplierLedger/SupplierLedgerDetailsPage";

import SupplierLedgerPage from "./components/dashboard/components/AdminComponent/BillingManagement/SupplierLedger/SupplierLedgerPage";

/*
|--------------------------------------------------------------------------
| PAYMENT OUT
|--------------------------------------------------------------------------
*/

import PaymentOutPage from "./components/dashboard/components/AdminComponent/BillingManagement/PaymentOut/PaymentOutPage";

import PaymentOutDetailsPage from "./components/dashboard/components/AdminComponent/BillingManagement/PaymentOut/PaymentOutDetailsPage";

/*
|--------------------------------------------------------------------------
| PURCHASE BILLS
|--------------------------------------------------------------------------
*/

import PurchaseBillViewPage from "./components/dashboard/components/AdminComponent/BillingManagement/PurchaseBills/PurchaseBillViewPage";

import PurchaseBillFormPage from "./components/dashboard/components/AdminComponent/BillingManagement/PurchaseBills/PurchaseBillFormPage";

import PurchaseBillListPage from "./components/dashboard/components/AdminComponent/BillingManagement/PurchaseBills/PurchaseBillListPage";

/*
|--------------------------------------------------------------------------
| SUPPLIERS
|--------------------------------------------------------------------------
*/

import SupplierListPage from "./components/dashboard/components/AdminComponent/BillingManagement/Suppliers/SupplierListPage";

import SupplierFormPage from "./components/dashboard/components/AdminComponent/BillingManagement/Suppliers/SupplierFormPage";

import SupplierViewPage from "./components/dashboard/components/AdminComponent/BillingManagement/Suppliers/SupplierViewPage";

/*
|--------------------------------------------------------------------------
| SUPPLIER PAYABLE
|--------------------------------------------------------------------------
*/

import SupplierPayablesPage from "./components/dashboard/components/AdminComponent/BillingManagement/SupplierPayables/SupplierPayablesPage";

import SupplierPayableDetailsPage from "./components/dashboard/components/AdminComponent/BillingManagement/SupplierPayables/SupplierPayableDetailsPage";

/*
|--------------------------------------------------------------------------
| REPORTS
|--------------------------------------------------------------------------
*/

import PurchaseReportsPage from "./components/dashboard/components/AdminComponent/BillingManagement/PurchaseReports/PurchaseReportsPage";

import GstDashboardPage from "./components/dashboard/components/AdminComponent/BillingManagement/GST/GstDashboardPage";

/*
|--------------------------------------------------------------------------
| DASHBOARD
|--------------------------------------------------------------------------
*/

import DashboardPage from "./components/dashboard/components/AdminComponent/dashboardManagement/DashboardPage.jsx";
import PlatformSubscriptionList from "./components/dashboard/components/platformComponent/subscriptions/PlatformSubscriptionList.js";
import PlatformTenantUserList from "./components/dashboard/components/platformComponent/tenantUsers/PlatformTenantUserList.js";
import PlatformActivityList from "./components/dashboard/components/platformComponent/activity/PlatformActivityList.js";
import PlatformActivityDetails from "./components/dashboard/components/platformComponent/activity/PlatformActivityDetails.js";
import PlatformSubscriptionDetails from "./components/dashboard/components/platformComponent/subscriptions/PlatformSubscriptionDetails.js";
import PlatformSettings from "./components/dashboard/components/platformComponent/settings/PlatformSettings.js";
import PlatformSubscriptionPlanList from "./components/dashboard/components/platformComponent/subscriptions/SubscriptionPlan/PlatformSubscriptionPlanList.js";
import SettingsLayout from "./components/dashboard/components/AdminComponent/Settings/SettingsLayout.jsx";
import RoleManagement from "./components/dashboard/components/AdminComponent/EmployeeManagement/RolesManagement/RoleManagement.jsx";
import Subscription from "./components/dashboard/components/AdminComponent/subscription/TenantSubscriptionPage.jsx";
import BusinessPartnerLeadsPage from "./components/dashboard/components/platformComponent/MarketingLeads/BusinessPartnerLeads/BusinessPartnerLeadsPage.jsx";
import SellDeviceLeadsPage from "./components/dashboard/components/platformComponent/MarketingLeads/SellDeviceLeads/SellDeviceLeadsPage.jsx";
import PlatformSupportPage from "./components/dashboard/components/platformComponent/support/PlatformSupportPage.jsx";
import Signup from "./components/auth/Signup.js";

/*
|--------------------------------------------------------------------------
| ROUTES
|--------------------------------------------------------------------------
*/

const Routes = () => {
  return (
    <Router history={history}>
      <Switch>
        {/*
                |--------------------------------------------------------------------------
                | PLATFORM LOGIN
                |--------------------------------------------------------------------------
                |
                | IMPORTANT:
                |
                | Do NOT use tenant GuestGuard here.
                |
                | Platform authentication uses:
                |
                | platformAccessToken
                |
                |--------------------------------------------------------------------------
                */}

        <Route exact path="/platform/login" component={PlatformLogin} />

        <Route
          exact
          path="/employee-offer/:token"
          component={EmployeeOfferPublic}
        />
        <PlatformAuthGuard
          exact
          path="/platform/subscriptions"
          component={PlatformSubscriptionList}
        />

        <PlatformAuthGuard
          exact
          path="/platform/subscriptions/:id"
          component={PlatformSubscriptionDetails}
        />
        <PlatformAuthGuard
          exact
          path="/platform/tenant-users"
          component={PlatformTenantUserList}
        />
        <PlatformAuthGuard
          exact
          path="/platform/activity"
          component={PlatformActivityList}
        />
        <PlatformAuthGuard
          exact
          path="/platform/activity/:id"
          component={PlatformActivityDetails}
        />
        <PlatformAuthGuard
          exact
          path="/platform/settings"
          component={PlatformSettings}
        />
        <PlatformAuthGuard
          exact
          path="/platform/subscription-plans"
          component={PlatformSubscriptionPlanList}
        />
        <PlatformAuthGuard
          exact
          path="/platform/website-users"
          component={UserManagement}
        />
        {/*
                |--------------------------------------------------------------------------
                | PLATFORM DASHBOARD
                |--------------------------------------------------------------------------
                */}

        <PlatformAuthGuard
          exact
          path="/platform/dashboard"
          component={PlatformDashboard}
        />

        {/*
                |--------------------------------------------------------------------------
                | PLATFORM BUSINESSES
                |--------------------------------------------------------------------------
                */}

        <PlatformAuthGuard
          exact
          path="/platform/businesses"
          component={PlatformBusinessList}
        />

        <PlatformAuthGuard
          exact
          path="/platform/businesses/:id"
          component={PlatformBusinessDetails}
        />

        <PlatformAuthGuard
          exact
          path="/platform/business-partner-leads"
          component={BusinessPartnerLeadsPage}
        />

        <PlatformAuthGuard
          exact
          path="/platform/sell-device-leads"
          component={SellDeviceLeadsPage}
        />
        <PlatformAuthGuard
          exact
          path="/platform/support"
          component={PlatformSupportPage}
        />
        {/*
                |--------------------------------------------------------------------------
                | TENANT LOGIN
                |--------------------------------------------------------------------------
                */}

        <GuestGuard exact path="/" component={Login} />
        <GuestGuard exact path="/register" component={Signup} />

        {/*
                |--------------------------------------------------------------------------
                | TENANT DASHBOARD
                |--------------------------------------------------------------------------
                |
                | Keep dashboard available to every authenticated tenant user.
                |--------------------------------------------------------------------------
                */}

        <AuthGuard exact path="/dashboard" component={DashboardPage} />

        {/*
                |--------------------------------------------------------------------------
                | TENANT PROFILE
                |--------------------------------------------------------------------------
                |
                | Every authenticated tenant user can view own profile.
                |--------------------------------------------------------------------------
                */}

        <AuthGuard exact path="/profile" component={TenantProfile} />

        {/*
                |--------------------------------------------------------------------------
                | ORDER MANAGEMENT
                |--------------------------------------------------------------------------
                |
                | Auth only for now.
                |
                | We will add the exact permission after verifying its backend route.
                |--------------------------------------------------------------------------
                */}

        <AuthGuard exact path="/order-management" component={OrderManagement} />

        {/*
                |--------------------------------------------------------------------------
                | CUSTOMER REQUIREMENTS
                |--------------------------------------------------------------------------
                */}

        <AuthGuard
          exact
          path="/customer-requirments"
          component={CustomerService}
        />

        {/*
                |--------------------------------------------------------------------------
                | INVENTORY
                |--------------------------------------------------------------------------
                */}

        <AuthGuard
          exact
          path="/inventory-management"
          component={InventoryManagement}
        />

        {/*
                |--------------------------------------------------------------------------
                | EMPLOYEE MANAGEMENT
                |--------------------------------------------------------------------------
                */}

        {/*
                |--------------------------------------------------------------------------
                | TASK MANAGEMENT
                |--------------------------------------------------------------------------
                */}

        <AuthGuard exact path="/task-management" component={TaskManagement} />

        {/*
                |--------------------------------------------------------------------------
                | SUPPORT CHAT
                |--------------------------------------------------------------------------
                */}

        <AuthGuard
          exact
          path="/support-chat"
          component={SupportChat}
          showChat={false}
        />

        {/*
                |--------------------------------------------------------------------------
                | USER MANAGEMENT
                |--------------------------------------------------------------------------
                */}

        {/*
                |--------------------------------------------------------------------------
                | SYSTEM CONFIGURATION
                |--------------------------------------------------------------------------
                */}

        {/*
                |--------------------------------------------------------------------------
                | QUOTATIONS
                |--------------------------------------------------------------------------
                */}

        <AuthGuard
          exact
          path="/billing/quotations"
          component={QuotationPage}
          permission="quotation.view"
        />

        <AuthGuard
          exact
          path="/billing/quotations/create"
          component={QuotationFormPage}
          permission="quotation.create"
        />

        <AuthGuard
          exact
          path="/billing/quotations/:id/edit"
          component={QuotationFormPage}
          permission="quotation.update"
        />

        <AuthGuard
          exact
          path="/billing/quotations/:id/history"
          component={QuotationHistoryPage}
          permission="quotation.history"
        />

        <AuthGuard
          exact
          path="/billing/quotations/:id/print"
          component={QuotationPrintPage}
          permission="quotation.view"
        />

        <AuthGuard
          exact
          path="/billing/quotations/:id"
          component={QuotationViewPage}
          permission="quotation.view"
        />

        {/*
                |--------------------------------------------------------------------------
                | SALE INVOICES
                |--------------------------------------------------------------------------
                */}

        <AuthGuard
          exact
          path="/billing/sale-invoices"
          component={SaleInvoiceManagement}
          permission="sale_invoice.view"
        />

        <AuthGuard
          exact
          path="/billing/sale-invoices/create"
          component={SaleInvoiceFormPage}
          permission="sale_invoice.create"
        />

        <AuthGuard
          exact
          path="/billing/sale-invoices/:id/edit"
          component={SaleInvoiceFormPage}
          permission="sale_invoice.update"
        />

        <AuthGuard
          exact
          path="/billing/sale-invoices/:id/view"
          component={SaleInvoiceViewPage}
          permission="sale_invoice.view"
        />

        <AuthGuard
          exact
          path="/billing/sale-invoices/:id/print"
          component={SaleInvoicePrintPage}
          permission="sale_invoice.view"
        />

        {/*
                |--------------------------------------------------------------------------
                | BILLING PAYMENTS
                |--------------------------------------------------------------------------
                */}

        <AuthGuard
          exact
          path="/billing/payments"
          component={PaymentListPage}
          permission="billing_payment.view"
        />

        {/*
                |--------------------------------------------------------------------------
                | CREDIT NOTES
                |--------------------------------------------------------------------------
                */}

        <AuthGuard
          exact
          path="/billing/credit-notes"
          component={CreditNoteListPage}
          permission="credit_note.view"
        />

        <AuthGuard
          exact
          path="/billing/credit-notes/:id"
          component={CreditNoteViewPage}
          permission="credit_note.view"
        />

        {/*
                |--------------------------------------------------------------------------
                | CUSTOMER LEDGER
                |--------------------------------------------------------------------------
                */}

        <AuthGuard
          exact
          path="/billing/customer-ledger"
          component={CustomerLedgerPage}
          permission="customer_ledger.view"
        />

        {/*
                |--------------------------------------------------------------------------
                | DEBIT NOTES
                |--------------------------------------------------------------------------
                */}

        <AuthGuard
          exact
          path="/billing/debit-notes"
          component={DebitNoteListPage}
          permission="debit_note.view"
        />

        <AuthGuard
          exact
          path="/billing/debit-notes/:id"
          component={DebitNoteViewPage}
          permission="debit_note.view"
        />

        {/*
                |--------------------------------------------------------------------------
                | SUPPLIER LEDGER
                |--------------------------------------------------------------------------
                */}

        <AuthGuard
          exact
          path="/billing/supplier-ledger"
          component={SupplierLedgerPage}
          permission="supplier_ledger.view"
        />

        <AuthGuard
          exact
          path="/billing/supplier-ledger/:supplierId"
          component={SupplierLedgerDetailsPage}
          permission="supplier_ledger.view"
        />

        {/*
                |--------------------------------------------------------------------------
                | PAYMENT OUT
                |--------------------------------------------------------------------------
                */}

        <AuthGuard
          exact
          path="/billing/payment-out"
          component={PaymentOutPage}
          permission="payment_out.view"
        />

        <AuthGuard
          exact
          path="/billing/payment-out/:id"
          component={PaymentOutDetailsPage}
          permission="payment_out.view"
        />

        {/*
                |--------------------------------------------------------------------------
                | PURCHASE BILLS
                |--------------------------------------------------------------------------
                */}

        <AuthGuard
          exact
          path="/billing/purchase-bills"
          component={PurchaseBillListPage}
          permission="purchase_bill.view"
        />

        <AuthGuard
          exact
          path="/billing/purchase-bills/create"
          component={PurchaseBillFormPage}
          permission="purchase_bill.create"
        />

        <AuthGuard
          exact
          path="/billing/purchase-bills/:id/edit"
          component={PurchaseBillFormPage}
          permission="purchase_bill.update"
        />

        <AuthGuard
          exact
          path="/billing/purchase-bills/:id"
          component={PurchaseBillViewPage}
          permission="purchase_bill.view"
        />

        {/*
                |--------------------------------------------------------------------------
                | SUPPLIERS
                |--------------------------------------------------------------------------
                */}

        <AuthGuard
          exact
          path="/billing/suppliers"
          component={SupplierListPage}
          permission="supplier.view"
        />

        <AuthGuard
          exact
          path="/billing/suppliers/create"
          component={SupplierFormPage}
          permission="supplier.create"
        />

        <AuthGuard
          exact
          path="/billing/suppliers/:id/edit"
          component={SupplierFormPage}
          permission="supplier.update"
        />

        <AuthGuard
          exact
          path="/billing/suppliers/:id"
          component={SupplierViewPage}
          permission="supplier.view"
        />

        {/*
                |--------------------------------------------------------------------------
                | SUPPLIER PAYABLES
                |--------------------------------------------------------------------------
                */}

        <AuthGuard
          exact
          path="/billing/supplier-payables"
          component={SupplierPayablesPage}
          permission="supplier_payable.view"
        />

        <AuthGuard
          exact
          path="/billing/supplier-payables/:supplierId"
          component={SupplierPayableDetailsPage}
          permission="supplier_payable.view"
        />

        {/*
                |--------------------------------------------------------------------------
                | PURCHASE REPORTS
                |--------------------------------------------------------------------------
                */}

        <AuthGuard
          exact
          path="/billing/purchase-reports"
          component={PurchaseReportsPage}
          permission="purchase_report.view"
        />

        {/*
                |--------------------------------------------------------------------------
                | GST REPORT
                |--------------------------------------------------------------------------
                */}

        <AuthGuard
          exact
          path="/billing/gst"
          component={GstDashboardPage}
          permission="gst_report.view"
        />
        <AuthGuard exact path="/settings" component={SettingsLayout} />

        {/* EMPLOYEE MANAGMENT ROUTE */}
        {/* =========================================================
    EMPLOYEE MANAGEMENT
========================================================= */}

        <AuthGuard
          exact
          path="/employees"
          component={EmployeeManagement}
          permission="employee.view"
        />

        {/* =========================================================
    EMPLOYEE ATTENDANCE
========================================================= */}

        <AuthGuard
          exact
          path="/employees/attendance"
          component={EmployeeAttendance}
          permission="employee.attendance.view"
        />

        {/* =========================================================
    EMPLOYEE LEAVE
========================================================= */}

        <AuthGuard
          exact
          path="/employees/leaves"
          component={EmployeeLeave}
          permission="employee.leave.view"
        />

        {/* =========================================================
    EMPLOYEE SALARY
========================================================= */}

        <AuthGuard
          exact
          path="/employees/salary"
          component={EmployeeSalary}
          permission="employee.salary.view"
        />

        {/* =========================================================
    EMPLOYEE ADVANCE
========================================================= */}

        <AuthGuard
          exact
          path="/employees/advances"
          component={EmployeeAdvance}
          permission="employee.advance.view"
        />

        <AuthGuard
          exact
          path="/employees/offers"
          component={EmployeeOfferManagement}
          permission="employee.view"
        />

        {/* =========================================================
    ROLE & PERMISSION MANAGEMENT
========================================================= */}

        <AuthGuard
          exact
          path="/employee/role-permission"
          component={RoleManagement}
          permission="employee.role.view"
        />
        <AuthGuard
          exact
          path="/employees/offers"
          component={RoleManagement}
          permission="employee.offers.view"
        />
        <AuthGuard exact path="/subscription" component={Subscription} />
      </Switch>
    </Router>
  );
};

export default Routes;
